import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './RecruiterHeader.css';

const RecruiterHeader = ({ currentView = 'assessments' }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  return (
    <header className="recruiter-header">
      <div className="header-content">
        <div className="logo-section">
          <h1 className="logo">SecHire</h1>
          <span className="recruiter-badge">RECRUITER</span>
        </div>
        <nav className="recruiter-nav">
          {user?.role === 'admin' && (
            <button
              className="nav-link"
              onClick={() => navigate('/admin/dashboard')}
            >
              Admin Panel
            </button>
          )}
          <button
            className={`nav-link ${currentView === 'assessments' ? 'active' : ''}`}
            onClick={() => navigate('/recruiter/assessments')}
          >
            Assessments
          </button>
          <button
            className={`nav-link ${currentView === 'jobs' ? 'active' : ''}`}
            onClick={() => navigate('/recruiter/jobs')}
          >
            Jobs
          </button>
          <button
            className={`nav-link ${currentView === 'approvals' ? 'active' : ''}`}
            onClick={() => navigate('/recruiter/approvals')}
          >
            Approvals
          </button>
          <button
            className={`nav-link ${currentView === 'talent-pool' ? 'active' : ''}`}
            onClick={() => navigate('/recruiter/talent-pool')}
          >
            Talent Pool
          </button>
        </nav>
        <div className="user-menu">
          <span className="user-email">{user?.email}</span>
          <button className="cyber-btn danger" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>
    </header>
  );
};

export default RecruiterHeader;
